import React from "react";

import Layout from "../../components/layout";
import Seo from "../../components/SEO";
import TechnologyIndexContent from "../../containers/technology-page/technology-index";

const TechnologyIndexPage = () => {
  return (
    <Layout>
      <Seo
        title="Technologies"
        description="React and Vue work for established SaaS frontends, with selected projects for each stack."
      />
      <TechnologyIndexContent />
    </Layout>
  );
};

export default TechnologyIndexPage;
